import { _query } from './query.js'

function saveEmailToCookie(value) {
	setCookie('savedEmail', value, 0.02, '')
}

export function catchEmail(form) {
	// $(form).on({
	//   focus: () => {
	//     const value = $(form).val()
	//     saveEmailToCookie(value)
	//   },
	//   // blur: () => {
	//   //  const value = $(form).val()
	//   //  saveEmailToCookie(value)
	//   // },
	//   keyup: () => {
	//     const value = $(form).val()
	//     saveEmailToCookie(value)
	//   },
	//   keydown: () => {
	//     const value = $(form).val()
	//     saveEmailToCookie(value)
	//   }
	// })
	const events = 'focus keyup keydown'
	$(form).on(events, () => {
		const value = $(form).val()
		saveEmailToCookie(value)
	})
}

export function getMlistVal(form) {
	const enableMarketingList = $('.enter-email-wrapper').attr(
		'data-marketing-list'
	)
	const checkForm = _query(form)
	if (enableMarketingList == 1 && checkForm) {
		const testChecked = checkForm.checked
		if (testChecked) {
			setCookie('mListOptIn', 1, 0.02, '')
		} else {
			setCookie('mListOptIn', 0, 0.02, '')
		}
	}
}

export function catchMListOptIn(form) {
	// const lfckv = document.querySelector(form).checked
	const events = 'click blur change focus'
	$(form).on(events, () => {
		getMlistVal(form)
		// const value = $(form).val()
		// const testChecked = document.querySelector(form).checked
		// if (testChecked) {
		//   setCookie('mListOptIn', 1, 0.02, '')
		// } else {
		//   setCookie('mListOptIn', 0, 0.02, '')
		// }
	})
}
